import './ImageSlider.scss';
import { imagePlaceHolder } from '../../utils/images';
import { useDisplayImage } from '../../hook/useDisplayImage';
import { CSSProperties, useState, useEffect } from 'react';

interface ImageSliderProps {
  images: string[];
  displayId: number;
}

export const ImageSlider: React.FC<ImageSliderProps> = ({ images, displayId }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    setCurrentImageIndex(prev => (images.length > 0 && prev >= images.length ? images.length - 1 : prev)); 
  }, [images.length]);
  
  const { imageUrl, loading, error } = useDisplayImage({
    url: images[currentImageIndex] || ''
  });

  if (images.length === 0) {
    return (
      <img
        src={imagePlaceHolder}
        alt="No images available"
        className="image-slider__preview-image image-slider__preview-image--placeholder"
      />
    );
  }

  const handleDotClick = (index: number) => {
    setCurrentImageIndex(index);
  };

  const imageContainerStyle = imageUrl
    ? ({ '--image-slider-background': `url("${imageUrl}")` } as CSSProperties)
    : undefined;

  return (
    <div className="image-slider">
      <div className="image-slider__image-container" style={imageContainerStyle}>
        {loading ? (
          <div className="image-slider__loading">Loading...</div>
        ) : error ? (
          <img
            src={imagePlaceHolder}
            alt=""
            className="image-slider__preview-image image-slider__preview-image--placeholder"
          />
        ) : (
          <img
            src={imageUrl || imagePlaceHolder}
            alt={`Display ${displayId} - ${currentImageIndex + 1}`}
            className="image-slider__preview-image"
          />
        )}
      </div>
      
      {images.length > 1 && (
        <div className="image-slider__dots">
          {images.map((_, index) => (
            <button
              key={index}
              className={`image-slider__dot ${index === currentImageIndex ? 'image-slider__dot--active' : ''}`}
              onClick={() => handleDotClick(index)}
              aria-label={`View image ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}; 